<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--TERMS AND CONDITIONS PAGE-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="termsAndConditions; else unavailable">
    <section class="terms-and-conditions margin-top-offset">
      <div class="wrapper">
        <!--SHARED CMS STATIC PAGE-->
        <app-static-page
          [title]="termsAndConditions.title"
          [bodyContent]="termsAndConditions.content | safe : 'html'">
        </app-static-page>
        <!--END SHARED CMS STATIC PAGE-->
      </div>
    </section>
  </ng-container>
</ng-template>
<!--END TERMS AND CONDITIONS PAGE-->
<ng-template #unavailable>
  <section>
    <p class="wrapper">
      Sorry for the inconvience. We are not able to load content at this time due to technical
      difficulties.
    </p>
  </section>
</ng-template>
